// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8e1bbcb9","488":"0ae0db97"}[chunkId] + ".chunk.js";
};